// extracted by mini-css-extract-plugin
export default {"productCategoryCell":"ProductCategoryCell_productCategoryCell__Qbqo1"};